<template>
  <div class="prism">
    <Spacer class="h-full">
      <Container class="h-full">
        <div class="h-full flex flex-col items-center gap-8 sm:gap-16">
          <div class="text-center">
            <Heading align-center level="h2">{{ I18n.t("upload_widget.heading") }}</Heading>
            <div class="!mt-2">{{ I18n.t("upload_widget.text_mobile") }}</div>
          </div>
          <UploadWidget />
        </div>
      </Container>
    </Spacer>
  </div>
</template>

<script setup>
import "@/src/i18n";
import { inject } from "vue";
import { Spacer, Container, Heading, Curve, Star } from "prism";
import UploadWidget from "./upload_widget.vue";

const I18n = inject("I18n");
</script>
